import React from 'react';
import './index.css';
import FlightsTable from '../../components/flightsTable';
import AlertBar from '../../components/alertBar';
import queryString from 'query-string';
import moment from 'moment';
import config from '../../config';
import flightService from '../../services/flight';

function startTime() {
  const date = moment().format('DD MMM YYYY - HH:mm:ss');

  document.getElementById('clock-text').innerHTML = date;

  setTimeout(startTime, 1000);
}

function queryParams(path) {
  const parsed = queryString.parse(path);

  let ret = {};

  if (parsed) {
    ret = {
      arrivals: parsed.arrivals === 'true',
      departures: parsed.departures === 'true'
    };
  }

  return ret;
}

export default (props, routerProps) => ({
  componentDidMount() {
    setTimeout(() => {
      return flightService.data()
      .then(() => {
        location.reload();
      })
      .catch(() => {
        console.log('ERROR! Do not refresh page');
      })
    }, config.tvPageRefreshInterval);
    startTime();
  },

  render() {
    const _queryParams = queryParams(this.props.location.search);

    const flightsTableProps = {
      tv: true,
      queryParams: this.props.location.search,
      textFont: props.textFont,
      textColor: props.textColor,
      textBackgroundColor: props.textBackgroundColor,
      backgroundColor: props.backgroundColor,
      alertColor: props.alertColor,
      alertBackgroundColor: props.alertBackgroundColor,
      global: props.global
    };

    const style = {
      backgroundColor: props.backgroundColor
    };

    let headerText = 'FLIGHTS';
    let headerIcon = '';

    if (_queryParams.departures) {
      headerText = 'DEPARTURES';
      headerIcon = '/assets/images/icon_departures.png';
    } else if (_queryParams.arrivals) {
      headerText = 'ARRIVALS';
      headerIcon = '/assets/images/icon_arrivals.png';
    }

    return (
      <div className="viewsTV" style={style}>
        <div className="viewsTV__top">
          <img className="logo" src="/assets/images/logo_aeroport_small.png" alt="" />
          <span className="headerText">{headerText}</span>
          <img className="headerIcon" src={headerIcon} alt="" />
          <span className="clock" id="clock-text"></span>
        </div>

        <div className="clearfix"></div>

        <AlertBar showLink={false} tv={true} />
        <FlightsTable {...flightsTableProps} />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/tv/index.js